<template>
  <div class="col-sm-12" style="">
    <div v-if="action != 'create'">
      <h4 class="heading">Basic Details</h4><hr>
      <div class="row">
        <div class="col-sm-4 form-group">
          <label>Contract Note : &nbsp;&nbsp;</label>
          <span v-if="action=='view'">{{formInput.contract_note}}</span>
          <input v-else type="text" :readonly="!can_access('change_contract_note','modify') || action == 'create'" placeholder="" class="only-border-bottom" v-model="formInput.contract_note">
        </div>    
        <!-- <div class="col-sm-4 form-group">
          <label>Ticket Number : &nbsp;&nbsp;</label>
          <span v-if="action=='view'">{{formInput.ticket_number}}</span>
          <input v-else type="text" :readonly="!can_access('change_ticket_number','modify') || action == 'create'" placeholder="" class="only-border-bottom" v-model="formInput.ticket_number">
        </div>   -->
      </div>
      <!-- <div v-if="['BUY','SELL','FOP IN','FOP OUT','TRANSFER IN','TRANSFER OUT'].indexOf(formInput.type)>=0" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.counterparty_id')}">
        <span v-if="formInput.action=='view'"><label>Counterparty : &nbsp;&nbsp;</label>{{formInput.counterparty_name||'-'}}</span>
        <b-input-group v-else>
          <template v-slot:prepend>
            <b-input-group-text >Counterparty</b-input-group-text>
          </template>
          <select name="type" ref="counterparty" class="form-control" v-model="formInput.counterparty_id">
            <option selected value="">Select Counterparty</option>
            <option v-for="counterparty in counterparties" :key="counterparty.id" :value="counterparty.id">{{counterparty.name}}</option>
          </select>
        </b-input-group>
      </div>
      <div v-if="['BUY','SELL','FOP IN','FOP OUT','TRANSFER IN','TRANSFER OUT'].indexOf(formInput.type)>=0" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.custodian_id')}">
        <span v-if="formInput.action=='view'"><label>Custodian : &nbsp;&nbsp;</label>{{formInput.custodian_name||'-'}}</span>
        <b-input-group v-else>
          <template v-slot:prepend>
            <b-input-group-text >Custodian</b-input-group-text>
          </template>
          <select name="type" ref="custodian" class="form-control" v-model="formInput.custodian_id">
            <option selected value="">Select Custodian</option>
            <option v-for="custodian in custodians" :key="custodian.id" :value="custodian.id">{{custodian.name}}</option>
          </select>
        </b-input-group>
      </div>
      <div v-if="['BUY','SELL','FOP IN','FOP OUT','TRANSFER IN','TRANSFER OUT'].indexOf(formInput.type)>=0" class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.capacity')}">
        <span v-if="formInput.action=='view'"><label>Capacity : &nbsp;&nbsp;</label>{{formInput.capacity||'-'}}</span>
        <b-input-group v-else>
          <template v-slot:prepend>
            <b-input-group-text >Capacity</b-input-group-text>
          </template>
          <select name="type" ref="capacity" class="form-control" v-model="formInput.capacity">
            <option value="">Select Capacity</option>
            <option selected value="AOTC">AOTC</option>
            <option value="MTCH">MTCH</option>
          </select>
        </b-input-group>
      </div> -->
    </div>
    <h4 class="heading">Account Detail</h4><hr>
    <div class="row">
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.account_number')}">
        <label>Account Number<span v-if="action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.account_number') }}</span>
        <span v-if="action=='view'">{{formInput.account_number}}</span>
        <vue-bootstrap-typeahead
            v-else
            :ref="'account_number'"
            :data="customers"
            v-model="formInput.account_number"
            :serializer="customerFormattedDisplay"
            placeholder="Search Account No."
            @hit="setCustomerInfo"
        />
        </div>    
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.client_name')}">
        <label>Client Name<span v-if="action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.client_name') }}</span>
        <span v-if="action=='view'">{{formInput.client_name}}</span>
        <input v-else type="text" placeholder="Enter Client Name Here.." class="form-control" v-model="formInput.client_name" readonly>
        </div> 
        <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.quantity')}">
        <label>Quantity<span v-if="action=='view'"> : &nbsp;&nbsp;</span></label><span class="message">{{ validation.firstError('formInput.quantity') }}</span>
        <span v-if="action=='view'">{{Number(parseFloat(formInput.quantity).toFixed(2)).toLocaleString('ja-JP')}}</span>
        <input v-else type="text" ref="quantity" placeholder="Enter Quantity Here.." class="form-control" v-model="display_quantity">
        </div>
    </div> 
  </div>
</template>
<script>
import SimpleVueValidator from 'simple-vue-validator';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
import 'vue-material/dist/vue-material.css';
import common from '@/assets/js/common.js';

const Validator = SimpleVueValidator.Validator;
export default {
    name: "AddBulkCustomer",
    props: ['row','action'],
    mixins: [common, SimpleVueValidator.mixin],
    components: {VueBootstrapTypeahead},
    data(){
        return {
          customers: [],
          display_quantity: '',
          formInput:{
            account_number: '',
            client_name: '',
            quantity: '',
            contract_note: '',
            /* ticket_number: '', */
          },
          stamp_duty_excemption : 0,
        };
    },
    validators: {
        'formInput.account_number' : function (value) {
            return Validator.value(value).required();
        },
        'formInput.client_name': function(value){
            return Validator.value(value);
        },
        'formInput.quantity': function(value){
            return Validator.value(value).required().float();
        },
        'formInput.contract_note': function(value){
          if(this.can_access('change_contract_note','modify') && this.action != 'create')
            return Validator.value(value).required();
        },/* 
        'formInput.ticket_number': function(value){
            return Validator.value(value).required();
        } */
    },
    created(){
      if(typeof this.row != 'undefined'){
        Object.assign(this.formInput, this.row);
        this.display_quantity = Number(this.formInput.quantity).toString();
      }
    },
    mounted(){
      if(this.action == 'view'){
        var el = this.$el.getElementsByTagName("label");
        for (var i = 0; i<el.length; i++) {
            el[i].style.fontWeight = 600;
        }
      }
    },
    watch: {
      display_quantity: function(newValue) {
        var result = newValue.replace(/[^0-9.]/g, "");
        this.formInput.quantity = result;
        result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        this.$nextTick(() => this.display_quantity = result);
      },
      'formInput.account_number': function (input) {
        if(this.$refs.hasOwnProperty('account_number')){
          this.getCustomer(input);
          this.$refs["account_number"].inputValue = input;
        }
      },
      /* quantity: function (input){
        this.$emit('quantity',input)
      } */
      formInput : {
        handler:function(value) {
          this.$emit('accountDetails',value)
        },
        deep : true,
      },
    },
    methods: {
        async getCustomer(input) {
          const limit = 10, offset = 0, sort = '', order = '';
          var filter = {'approved_at':{from_date:'2020-01-01'}}; 
          filter['account_number'] = input;
          let uri = 'customer_list?limit='+limit+'&offset='+offset+'&sort='+sort+'&order='+order+'&filter='+JSON.stringify(filter);
          const {response} = await this.call_axios(uri);
          this.customers = response.data?response.data.result:[];
        },
        setCustomerInfo (group) {
          //this.$refs["account_number_"+index].hasOwnProperty('inputValue')?(this.$refs["account_number_"+index].inputValue = group.account_number):(this.$refs["account_number_"+index][0].inputValue = group.account_number);
          this.$refs["account_number"].inputValue = group.account_number
          this.formInput.account_number = group.account_number;
          this.formInput.client_name = (typeof group == "object") ? group.firstname+' '+(group.lastname ? group.lastname : "") : "" ;
          // access the autocomplete component methods from the parent
          //this.$refs.account_number.clear()
        },
        customerFormattedDisplay (result) {
          return result.account_number+" ( "+result.firstname+""+(result.lastname?" "+result.lastname:"")+" )";
        }
    }
}
</script>